/**
 * Разбивает текст на части: обычный текст и ссылки
 */
export function parseTextWithLink(text: string): string[] {
  if (!text) return [];

  const urlRegex = /https?:\/\/[^\s]+/gi;

  const parts = text.split(urlRegex);
  const matches = text.match(urlRegex) || [];

  const result: string[] = [];

  // Ссылки всегда идут под нечетным индексом
  for (let i = 0; i < parts.length; i++) {
    result.push(parts[i]);

    if (i < matches.length) {
      result.push(matches[i]);
    }
  }

  return result;
}
